import defaultApi from '@/utils/request';

export default {
  // ===================S18W4001 個人差勤查詢 =========================================
  S18W4001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S18/S18W4001_Load',
      params,
    });
  },
  S18W4001_GetDetaildata(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S18/S18W4001_GetDetaildata',
      params,
    });
  },
  S18W4001_GetFileList(params) {
    return defaultApi({
      method: 'get',
      url: 'S01/S18/S18W4001_GetFileList',
      params,
    });
  },
  // ===================S18W4002 職務代理資料一覽表 =========================================
  S18W4002_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W4002_Load',
      params,
    });
  },
  S18W4002_Get_PrvAgentList(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W4002_Get_PrvAgentList',
      params,
    });
  },
  // ===================S18W4003 單位請假資料明細表 =========================================
  S18W4003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W4003_Load',
      params,
    });
  },
  S18W4003_Get_Selector(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W4003_Get_Selector',
      params,
    });
  },
  // ================= S18W2001 專案人員請假作業 =========================
  S18W2001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2001_Load',
      params,
    });
  },
  S18W2001_getVacApyd(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2001_getVacApyd',
      params,
    });
  },
  S18W2001_getDtList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2001_getDtList',
      params,
    });
  },
  S18W2001_getCourse(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2001_getCourse',
      params,
    });
  },
  S18W2001_postDtList(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2001_postDtList',
      data,
    });
  },
  S18W2001_getPagePdf(params) {
    // 列印頁面: 預算執行明細列表
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2001_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S18W2001_doFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2001_doFlow',
      params,
    });
  },
  S18W2001_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2001_savAction',
      data,
    });
  },
  S18W2001_LeaveAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2001_LeaveAttachmentViewLoad',
      params,
    });
  },
  S18W2001_LeaveAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2001_LeaveAttachmentViewFileUpload',
      data,
    });
  },
  S18W2001_LeaveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2001_LeaveAttachmentViewFileDelete',
      data,
    });
  },
  // ================= S18W2003 專案人員請假作業 =========================
  S18W2003_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2003_Load',
      params,
    });
  },
  S18W2003_getVacApyd(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2003_getVacApyd',
      params,
    });
  },
  S18W2003_getDtList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2003_getDtList',
      params,
    });
  },
  S18W2003_postDtList(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2003_postDtList',
      data,
    });
  },
  S18W2003_getPagePdf(params) {
    // 列印頁面: 預算執行明細列表
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2003_getPagePdf',
      responseType: 'blob',
      params,
    });
  },
  S18W2003_doFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2003_doFlow',
      params,
    });
  },
  S18W2003_savAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2003_savAction',
      data,
    });
  },
  S18W2003_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2003_SaveApply',
      data,
    });
  },
  S18W2003_LeaveAttachmentViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2003_LeaveAttachmentViewLoad',
      params,
    });
  },
  S18W2003_LeaveAttachmentViewFileUpload(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2003_LeaveAttachmentViewFileUpload',
      data,
    });
  },
  S18W2003_LeaveAttachmentViewFileDelete(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2003_LeaveAttachmentViewFileDelete',
      data,
    });
  },
  // ================= S18W2005 推廣教育教師請假作業 =========================
  // ================= S18W2007 校內調課單(教務處) =========================
  S18W2007_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_Load',
      params,
    });
  },
  S18W2007_getClassList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_getClassList',
      params,
    });
  },
  S18W2007_getApplyedList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_getApplyedList',
      params,
    });
  },
  S18W2007_getApplyedDetial(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_getApplyedDetial',
      params,
    });
  },
  S18W2007_getCourseView(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_getCourseView',
      params,
    });
  },
  S18W2007_getZpe101build(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_getZpe101build',
      params,
    });
  },
  S18W2007_getZpe101Room(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_getZpe101Room',
      params,
    });
  },
  S18W2007_getZpe101Teach(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_getZpe101Teach',
      params,
    });
  },
  S18W2007_SaveApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W2007_SaveApply',
      data,
    });
  },
  S18W2007_delS36Applied(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_delS36Applied',
      params,
    });
  },
  S18W2007_sendApplyFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_sendApplyFlow',
      params,
    });
  },
  S18W2007_rmApplyFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W2007_rmApplyFlow',
      params,
    });
  },

  // 加載列表 // S18W2008 兼任主管調班假申請作業 =========================
  S18W2008_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2008_LoadList',
      params,
    });
  },
  S18W2008_GetFlow(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2008_GetFlow',
      params,
    });
  },
  S18W2008_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2008_EditViewLoad',
      params,
    });
  },
  S18W2008_ShowViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2008_ShowViewLoad',
      params,
    });
  },
  S18W2008_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S18/S18W2008_EditViewAction',
      data,
    });
  },
  S18W2008_EditViewCheck(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2008_EditViewCheck',
      params,
    });
  },

  S18W2008_Delete(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S18/S18W2008_Delete',
      data,
    });
  },
  S18W2008_Abort(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S18/S18W2008_Abort',
      data,
    });
  },
  S18W2008_Send(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S18/S18W2008_Send',
      data,
    });
  },
  S18W2008_LoadPrintPDF(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2008_LoadPrintPDF',
      responseType: 'blob',
      params,
    });
  },
  // ================= S18W9001 進用、差假、薪資暨離校簽核作業(整合) =========================
  S18W9001_Load(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_Load',
      params,
    });
  },
  // 因為要傳遞 array 資料，無法使用 httpget 傳遞，改為 httppost
  S18W9001_GetListContent(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_GetListContent',
      data,
    });
  },
  S18W9001_GetPhrase(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_GetPhrase',
      params,
    });
  },
  S18W9001_GetCourseDetail(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_GetCourseDetail',
      params,
    });
  },
  S18W9001_GetChangeData(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_GetChangeData',
      params,
    });
  },
  S18W9001_SaveChangeData(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SaveChangeData',
      data,
    });
  },
  S18W9001_SubmitApply(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply',
      data,
    });
  },
  S18W9001_SubmitApply_501(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply_501',
      data,
    });
  },
  S18W9001_SubmitApply_50A(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply_50A',
      data,
    });
  },
  S18W9001_GetCancelVacation(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_GetCancelVacation',
      params,
    });
  },
  S18W9001_GetFileList(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_GetFileList',
      params,
    });
  },
  S18W9001_GetFileList_513(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_GetFileList_513',
      params,
    });
  },
  S18W9001_GetVacation(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_GetVacation',
      data,
    });
  },
  S18W9001_GetLeave(params) {
    return defaultApi({
      method: 'get',
      url: 'S07/S18/S18W9001_GetLeave',
      params,
    });
  },
  S18W9001_SubmitApply_500(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply_500',
      data,
    });
  },
  S18W9001_SubmitApply_507(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply_507',
      data,
    });
  },
  S18W9001_SaveJobadd(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SaveJobadd',
      data,
    });
  },
  S18W9001_SaveTuning(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SaveTuning',
      data,
    });
  },
  S18W9001_SaveTutor(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SaveTutor',
      data,
    });
  },
  S18W9001_GetPrjSalary(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_GetPrjSalary',
      data,
    });
  },
  S18W9001_GetStaffSalary(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_GetStaffSalary',
      data,
    });
  },
  S18W9001_GetZPE506PASSAP(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_GetZPE506PASSAP',
      data,
    });
  },
  S18W9001_GetMonthSalary(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_GetMonthSalary',
      data,
    });
  },
  S18W9001_SubmitApply_505(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply_505',
      data,
    });
  },
  S18W9001_SubmitApply_506(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply_506',
      data,
    });
  },
  S18W9001_SubmitApply_513(data) {
    return defaultApi({
      method: 'post',
      url: 'S07/S18/S18W9001_SubmitApply_513',
      data,
    });
  },

  // 加載列表 // S18W2009 逾期申請作業
  S18W2009_LoadList(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2009_LoadList',
      params,
    });
  },
  S18W2009_EditViewLoad(params) {
    return defaultApi({
      method: 'get',
      url: 'S05/S18/S18W2009_EditViewLoad',
      params,
    });
  },
  S18W2009_EditViewAction(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S18/S18W2009_EditViewAction',
      data,
    });
  },
  S18W2009_Delete(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S18/S18W2009_Delete',
      data,
    });
  },
  S18W2009_Send(data) {
    return defaultApi({
      method: 'post',
      url: 'S05/S18/S18W2009_Send',
      data,
    });
  },
};
